module.exports = __webpack_public_path__ + "img/menuIcon1.f8c7b6e6.png";